import {IMythNFTMetadata} from "./bean/MythNFT";
import {IMythTheme} from "./bean/MythTheme";

function GetEnvVar(name: string): string {
    const envName = `REACT_APP_${name}`;
    const env = process.env[envName] || undefined;
    if (env === undefined) {
        throw new Error(`${envName} not set`);
    }
    return env;
}

export function getMythNFTSConfig(): IMythNFTConfig[] {
    return appEnv.supportedNetworks[0].mythNFTSConfig;
}

export function getMythPassConfig(): IMythPassConfig {
    return appEnv.supportedNetworks[0].mythPassConfig;
}

export interface INativeCurrency {
    name: string
    symbol: string
    decimals: number
}

export interface IMythNFTConfig {
    theme: IMythTheme,
    metadata: IMythNFTMetadata[]
}

export interface IMythPassConfig {
    contractAddr: string,
    claimEndTime: number,
    mythPassWhitelist:any
}

export interface IMythServer {
    apiPrefix: string
}

export interface IMarketplace {
    name: string
    mythPassUrl: string
    mythCollectionPrefix: string,
    nftUrl:string
}

export interface IActionConfig {
    actions:IAction[];
}

export interface IAction {
    themeId: number,
    nftTypeId: number,
    actionId: number
}

export interface INetworkConfig {
    name: string
    chainId: number
    blockExplorer: string
    rpcUrl: string
    nativeCurrency?: INativeCurrency,
    mythPassGraphApiUrl: string,
    mythNFTGraphApiUrl: string,
    mythNFTSConfig: IMythNFTConfig[],
    mythPassConfig: IMythPassConfig,
    mythNFTManagerAddr: string,
    marketPlace: IMarketplace,
    actionConfig:IActionConfig
}

export interface IOpenseaConfig {
    apiKey: string
    apiUrl: string
    supportedNetworkIds: number[]
}

export interface OSSConfig {
    bucket: string
}

interface IEnv {
    supportedNetworks: INetworkConfig[]
    opensea: IOpenseaConfig
    mythServer: IMythServer,
    mythImageUrl:string,
    oss:OSSConfig
}

const envStr = GetEnvVar('ENV')

let appEnv: IEnv
appEnv = JSON.parse(envStr)

export {appEnv}
